const GROUP_ID_DEFAULT = "_____NOTHING_____";

class FirestoreDao {
  constructor(db, rootDoc, tmpOrders) {
    this.db = db;
    this.rootDoc = rootDoc;
    this.tmpOrders = tmpOrders;
  }

  base () {
    return this.db.doc(this.rootDoc);
  }

  findOrders () {
    return this.base().collection("orders");
  }

  //----------------------------------------
  // 表示データ作成
  //----------------------------------------
  async sleep (msec) {
    return new Promise(function (resolve) {
      setTimeout(resolve, msec);
    });
  }

  // vue-fire 用 (Promise 返却)
  // findMenus() {
  //   return this.base()
  //     .collection("menus")
  //     .orderBy("sort", "asc");
  // }

  async findMenus (publish) {
    // グルーピング前
    const menusQuery = this.base()
      .collection(`menus`)
      .where("publish", "==", publish ? true : false); // publish only
    const menusSS = await menusQuery.get();
    const menusData = menusSS.docs
      .map(docSS => docSS.data())
      .filter(data => "menuId" in data); // groups は除外
    // console.log(`menusData`, menusData);

    // グルーピング
    const groupMenuDatas = await this.createGroupMenuDatas(menusData);

    // グループ設定なし
    const noGroupMenuData = this.createNoGroupMenuData(menusData);

    // merge
    const mergedMenus = groupMenuDatas.concat([noGroupMenuData]);
    return mergedMenus;
  }

  async createGroupMenuDatas (menusData) {
    // グループデータ
    const menuGroups = await this.findMenuGroups();
    if (!menuGroups || menuGroups.length == 0) {
      return [];
    }
    const groups = menuGroups.groups;

    // グルーピング
    const newMenus = groups
      .sort((group1, group2) => group1.sort - group2.sort)
      .map((group) => {
        const groupId = group.id;
        const menus = menusData.filter((menu) => menu.groupIds.includes(groupId));

        // sort
        menus.sort((m1, m2) => {
          const m1Sort = m1.sorts.find(s => s.groupId === groupId);
          const m2Sort = m2.sorts.find(s => s.groupId === groupId);
          if (m1Sort.sort === m2Sort.sort) {
            // sort が同じ場合は updatedAt で比較
            const m1UpdatedAt = moment(m1.updatedAt.toDate());
            const m2UpdatedAt = moment(m2.updatedAt.toDate());
            return m1UpdatedAt.isBefore(m2UpdatedAt) ? 1 : -1;
          }
          return m1Sort.sort - m2Sort.sort;
        });
        // console.log(groupId, menus);

        return {
          group: group,
          menus: menus,
        };
      });
    return newMenus;
  }

  createNoGroupMenuData (menusData) {
    // カテゴリ未設定
    const noGroupMenus = menusData.filter(menu => menu.groupIds == null || menu.groupIds.length == 0);
    noGroupMenus.sort((m1, m2) => {
      // sort が同じ場合は updatedAt で比較
      const m1UpdatedAt = moment(m1.updatedAt.toDate());
      const m2UpdatedAt = moment(m2.updatedAt.toDate());
      return m1UpdatedAt.isBefore(m2UpdatedAt) ? 1 : -1;
    });

    // console.log(`noGroupMenus=${JSON.stringify(noGroupMenus)}`);
    const noGroupMenuData = {
      group: {
        id: GROUP_ID_DEFAULT,
        name: "その他",
        open: true,
        sort: 99999,
      },
      menus: noGroupMenus,
    };
    return noGroupMenuData;
  }

  // メニューグループ
  async findMenuGroups () {
    const docSS = await this.base()
      .collection("menus")
      .doc("groups")
      .get();
    const menuGroups = docSS.data();
    return menuGroups;
  }

  // メニュー詳細(新規)
  async findMenu (id) {
    const baseRef = this.base();
    const menuRef = baseRef.collection("menus").doc(id);

    let menuData = null;
    await menuRef.get().then(async (menuSS) => {
      if (menuSS.exists) {
        menuData = await this.createMergedMenuData(menuSS);
      }
    });
    return menuData;
  }

  async createMergedMenuData (menuSS) {
    // menuSS (DocumentReference)
    // - name: string
    // - image_url: string
    // - ...
    // - toppings: collection

    // menu
    const menuData = menuSS.data();

    const toppingsData = [];
    const toppings = menuData.toppings;
    // console.log(`toppingsData`, toppings);
    for (const t of toppings) {
      const toppingRef = await t.toppingRef.get();
      const topping = toppingRef.data();
      delete topping.menu; // 削除(ref)
      delete topping.toppingRef; // 削除(ref)

      // 選択肢 初期値 (先頭)
      const values = topping.values;
      if (values && values.length != 0) {
        topping.selected = values[0].id;
      }

      // console.log(`topping`, topping);
      toppingsData.push(topping);
    }

    menuData.toppings = toppingsData;

    return menuData;
  }

  // カート画面
  async createCartData (uuid) {
    // console.log("uuid", uuid);
    const baseRef = this.base();

    // /cartdoc
    // データなしケースもあり
    const cartSS = await baseRef
      .collection("users")
      .doc(uuid)
      .collection("cart")
      .doc("cartdoc")
      .get();
    const cartData = cartSS.data();

    // /cartdoc/menus
    const cartMenusRef = baseRef
      .collection("users")
      .doc(uuid)
      .collection("cart")
      .doc("cartdoc") //固定
      .collection("menus");

    const menusData = await this.createMenusDataForCart(cartMenusRef);

    // result
    const result = new Object();
    if (cartData && cartData.visitTime) {
      result.visitTime = cartData.visitTime;
    }
    result.menus = menusData;
    return result;
  }

  async createMenusDataForCart (cartMenusRef) {
    const cartMenusSS = await cartMenusRef.get();
    const menusData = [];
    await Promise.all(
      cartMenusSS.docs.map(async (cartMenuSS) => {
        const mergedMenuData = await this.createMergedMenuDataForCart(
          cartMenuSS
        );
        if (mergedMenuData) {
          mergedMenuData.cartMenuId = cartMenuSS.id;
          menusData.push(mergedMenuData);
        }
      })
    );

    // ソート(createdAt ASC)
    menusData.sort((m1, m2) => m1.createdAt - m2.createdAt);

    return menusData;
  }

  // メニュー詳細(編集)
  async createMenuDataFromCart (uuid, cartMenuId) {
    console.log("createMenu(from cart)", uuid, cartMenuId);
    const baseRef = this.base();
    const menuRef = baseRef
      .collection("users")
      .doc(uuid)
      .collection("cart")
      .doc("cartdoc") //固定
      .collection("menus")
      .doc(cartMenuId);

    const cartMenuSS = await menuRef.get();
    const menuData = await this.createMergedMenuDataForCart(cartMenuSS);
    if (!menuData) {
      return null;
    }
    console.log("menuData", menuData);
    menuData.cartMenuId = cartMenuId;
    return menuData;
  }

  async createMergedMenuDataForCart (cartMenuSS) {
    // メニュー情報(カート内)
    //   /cartdoc/menus/xxxxx

    // menu/toppings (入力情報なし)
    const cartMenuData = cartMenuSS.data();
    if (!cartMenuData) {
      // カート内にメニューが存在しない
      return null;
    }
    const menuId = cartMenuData.menuId; // menu
    const mergedData = await this.findMenu(menuId);
    if (!mergedData) {
      // /menus にメニューが存在しない
      return {
        menuId: cartMenuData.menuId,
        delete: true,
      };
    }

    // toppings
    const toppingsRef = await cartMenuSS.ref.collection("toppings");
    const toppingsData = await this.createToppingsDataForCart(toppingsRef);
    const toppingsApplied = mergedData.toppings.map((topping) => {
      const selectedTopping = toppingsData.find(
        (input) => topping.toppingId === input.toppingId
      );
      if (selectedTopping) {
        topping.selected = selectedTopping.selected;
      }
      return topping;
    });
    // console.log("### toppingsApplied", toppingsApplied);

    //---------------
    // 入力情報 適用
    //---------------
    mergedData.menuId = cartMenuData.menuId;
    mergedData.count = cartMenuData.count;
    mergedData.createdAt = cartMenuData.createdAt;
    mergedData.delete = cartMenuData.delete ?? false;
    mergedData.toppings = toppingsApplied;
    return mergedData;
  }

  async createMenuDataForCart (menuRef) {
    const doc = await menuRef.get();
    const menuData = doc.data();
    return menuData;
  }

  async createToppingsDataForCart (toppingsRef) {
    const toppingsSS = await toppingsRef.get();
    const toppingsData = [];
    await Promise.all(
      toppingsSS.docs.map(async (toppingSS) => {
        const topping = toppingSS.data();
        const toppingRef = topping.topping;
        const toppingData = await this.createToppingDataForCart(toppingRef);
        // console.log(`toppingData=>`, toppingData);

        // radioの場合のみ
        if (toppingData.type == "radio") {
          toppingData.selected = topping.selected;
        }
        toppingsData.push(toppingData);
      })
    );

    return toppingsData;
  }

  async createToppingDataForCart (toppingRef) {
    console.log("path", toppingRef.path);
    const doc = await toppingRef.get();
    var toppingData = doc.data();
    //TODO DB側も id->toppingId 対応したら消す
    // toppingData.toppingId = doc.data().id;
    return toppingData;
  }

  /**
   * カート内のメニューID群(論理削除対象のみ) 抽出
   * @param {*} userId 
   * @returns 
   */
  async findCartMenuIdsLogicallyDelete (userId) {
    const menusPath = `${this.rootDoc}/users/${userId}/cart/cartdoc/menus`;
    const menusSS = await this.db.collection(menusPath).where("delete", "==", true).get();
    const cartMenuIds = menusSS.docs.map(docSS => docSS.id);
    // console.log(`[findCartMenuIdsLogicallyDelete]`, cartMenuIds);
    return cartMenuIds;
  }

  async deleteCartMenuData (userId, menuId) {
    // toppings
    const toppingsPath = `${this.rootDoc}/users/${userId}/cart/cartdoc/menus/${menuId}/toppings`;
    const toppingsRef = this.db.collection(toppingsPath);
    const toppingsSS = await toppingsRef.get();
    toppingsSS.docs.forEach((docSS) => {
      docSS.ref.delete();
    });

    // menu
    const menuPath = `${this.rootDoc}/users/${userId}/cart/cartdoc/menus/${menuId}`;
    await this.db.doc(menuPath).delete();

    // cart
    const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);
    await cartRef.set({
      cartId: this.createNewCartId(),
    });
  }

  async updateCartId (userId) {
    // cart
    const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);
    await cartRef.set({
      cartId: this.createNewCartId(),
    });
  }

  // メニュー詳細(編集) from 注文履歴
  async createMenuDataFromHistory (orderId, orderMenuId) {
    console.log("createMenu(from history)", orderId, orderMenuId);

    // 注文情報
    const baseRef = this.base();
    const menuSS = await baseRef
      .collection("orders")
      .doc(orderId)
      .collection("menus")
      .doc(orderMenuId)
      .get();
    const historyMenuData = menuSS.data();
    console.log("historyMenuData", historyMenuData);

    //---------------
    // 入力情報
    //---------------
    const inputData = {
      orderMenuId: orderMenuId,
      // menuId: menuId,
      count: historyMenuData.count,
      toppings: historyMenuData.toppings,
    };
    console.log("### inputData", inputData);

    //---------------
    // メニュー情報(素)
    //---------------
    const menuId = historyMenuData.menuId; // menu
    const menuData = await this.findMenu(menuId);

    //---------------
    // 入力情報 適用
    //---------------
    menuData.orderMenuId = inputData.orderMenuId;
    menuData.count = inputData.count;

    // toppings
    const toppingsApplied = menuData.toppings.map((topping) => {
      const selectedTopping = inputData.toppings.find(
        (input) => topping.toppingId === input.toppingId
      );
      if (selectedTopping) {
        topping.selected = selectedTopping.selected;
      }
      return topping;
    });
    console.log("### toppingsApplied", toppingsApplied);
    menuData.toppings = toppingsApplied;
    return menuData;
  }

  // 注文履歴
  async findHistoryOrders (userId) {
    const baseRef = this.base();
    const ordersSS = await baseRef
      .collection("users")
      .doc(userId)
      .collection("orders")
      //TODO ページング(次の3件)
      // .limit(3)
      .get();

    const ordersData = [];
    await Promise.all(
      ordersSS.docs.map(async (orderSS) => {
        const data = orderSS.data();
        const orderRef = data.order;
        const orderData = await this.createHistoryOrderData(orderRef);
        orderData.orderId = data.orderId;
        orderData.createdAt = data.createdAt;
        ordersData.push(orderData);
      })
    );

    // ソート(createdAt DESC)
    // (非同期でデータ作成しているため個別に再ソート必要)
    ordersData.sort((m1, m2) => m2.createdAt - m1.createdAt);

    return ordersData;
  }

  async findHistoryOrder (userId, orderId) {
    const baseRef = this.base();
    const orderSS = await baseRef
      .collection("users")
      .doc(userId)
      .collection("orders")
      .doc(orderId)
      .get();

    const data = orderSS.data();
    if (data) {
      const orderRef = data.order;
      const orderData = await this.createHistoryOrderData(orderRef);
      console.log("orderData", orderData);
      return orderData;
    }
    return null;
  }

  async findHistoryOrderByCartId (userId, cartId) {
    const baseRef = this.base();
    const ordersSS = await baseRef
      .collection("users")
      .doc(userId)
      .collection("orders")
      .where("cartId", "==", cartId)
      .get();

    let orders = [];
    await Promise.all(
      ordersSS.docs.map(async (orderSS) => {
        const data = orderSS.data();
        const orderRef = data.order;
        const order = await this.createHistoryOrderData(orderRef);
        orders.push(order);
      })
    );
    // 1件のみ
    if (orders.length != 0) {
      return orders[0];
    }
    return {};
  }

  async createHistoryOrderData (orderRef) {
    // orderRef (DocumentReference)
    // - orderNo: string
    // - paid: number
    // - visitTime: string
    // - ...
    // - menus: collection
    let orderData = null;

    // order (1件のみ)
    await orderRef.get().then((doc) => {
      orderData = doc.data();
    });
    if (!orderData) {
      return {};
    }

    // menus (複数)
    const menusRef = await orderRef.collection("menus");
    const menusData = await this.createMenusDataForOrder(menusRef);
    orderData.menus = menusData;

    return orderData;
  }

  async createMenusDataForOrder (menusRef) {
    const menusSS = await menusRef.get();
    const tasks = menusSS.docs.map(async (menuSS) => {
      const menuData = menuSS.data();
      menuData.orderMenuId = menuSS.id;
      return menuData;
    });
    const menusData = await Promise.all(tasks);

    // ソート(createdAt ASC)
    menusData.sort((m1, m2) => m1.createdAt - m2.createdAt);

    return menusData;
  }

  // 注文履歴(直近1件)
  async findHistoryOrderRecent (userId) {
    const baseRef = this.base();
    const ordersSS = await baseRef
      .collection("users")
      .doc(userId)
      .collection("orders")
      .orderBy("createdAt", "desc")
      .limit(1)
      .get();

    var orderData = {};
    await Promise.all(
      ordersSS.docs.map(async (orderSS) => {
        orderData = orderSS.data();
      })
    );
    return orderData;
  }

  async addCart (userId, menu) {
    try {
      const updatedAt = Firebase.firestore.Timestamp.now();

      // cart
      await this.addCartProcess(userId, menu, updatedAt);

      // users(root)
      const userRef = this.db.doc(`${this.rootDoc}/users/${userId}`);
      await userRef.set({
        updatedAt: updatedAt,
      }, { merge: true }).catch(e => console.error(e));

      //[DELETE] tmpOrders
      await this.deleteTmpOrders(userId);

      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async updateCart (userId, menu) {
    try {
      const updatedAt = Firebase.firestore.Timestamp.now();

      // cart
      await this.updateCartProcess(userId, menu, updatedAt);

      // users(root)
      const userRef = this.db.doc(`${this.rootDoc}/users/${userId}`);
      await userRef.set({
        updatedAt: updatedAt,
      }, { merge: true }).catch(e => console.error(e));

      //[DELETE] tmpOrders
      this.deleteTmpOrders(userId);

      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async addCartProcess (userId, menu, updatedAt) {
    //TODO 1つでも失敗したら処理中断 (Promise.all と transaction)
    //TODO 存在チェック(メニュー) -> なければ処理中断
    //TODO 存在チェック(トッピング) -> なければ処理中断

    // cart
    const cartId = this.createNewCartId();
    const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);

    // cart(menu)
    const menuId = menu.menuId;
    const masterMenuRef = this.db.doc(`${this.rootDoc}/menus/${menuId}`);
    const cartNewMenuRef = this.db.collection(
      `${this.rootDoc}/users/${userId}/cart/cartdoc/menus`
    ).doc();
    const cartMenuId = cartNewMenuRef.id;

    return this.db.runTransaction(async (t) => {
      //TODO master データと比較 (menu, toppings)
      // await this.checkMasterData(t, menu);

      // cart
      t.set(cartRef, {
        cartId: cartId,
        updatedAt: updatedAt,
      });

      // cart(menu)
      t.set(cartNewMenuRef, {
        menuId: menuId,
        count: menu.count,
        menu: masterMenuRef,
        updatedAt: updatedAt,
      });

      // cart(toppings)
      const toppingTasks = menu.toppings.map(async (topping) => {
        // console.log("topping", topping);
        const toppingId = topping.toppingId;

        const masterToppingRef = this.db.doc(
          `${this.rootDoc}/toppings/${toppingId}`
        );
        console.log("master ref=>", masterToppingRef.path);
        const cartToppingRef = this.db.doc(
          `${this.rootDoc}/users/${userId}/cart/cartdoc/menus/${cartMenuId}/toppings/${toppingId}`
        );
        // console.log("cart ref =>", cartToppingRef.path);

        if (topping.type == "radio") {
          t.set(cartToppingRef, {
            toppingId: toppingId,
            selected: topping.selected,
            topping: masterToppingRef,
          });
        } else {
          t.set(cartToppingRef, {
            topping: masterToppingRef,
          });
        }
      });
      await Promise.all(toppingTasks);
    });
  }

  async updateCartProcess (userId, menu, updatedAt) {
    const cartId = this.createNewCartId();
    const cartMenuId = menu.cartMenuId;
    return this.db.runTransaction(async (t) => {
      // cart
      const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);
      t.set(cartRef, {
        cartId: cartId,
        updatedAt: updatedAt,
      }, { merge: true });

      // menu(cart)
      const cartMenuRef = this.db.doc(
        `${this.rootDoc}/users/${userId}/cart/cartdoc/menus/${cartMenuId}`
      );
      t.set(cartMenuRef, {
        count: menu.count,
        updatedAt: updatedAt,
      }, { merge: true });

      // toppings
      const toppingTasks = menu.toppings.map(async (topping) => {
        console.log("topping", topping);
        const toppingId = topping.toppingId;
        const targetRef = `${this.rootDoc}/users/${userId}/cart/cartdoc/menus/${cartMenuId}/toppings/${toppingId}`;
        const cartToppingRef = this.db.doc(targetRef);

        if (topping.type == "radio") {
          await cartToppingRef.update({
            selected: topping.selected,
          });
        }
      });
      await Promise.all(toppingTasks);
    });
  }

  createNewCartId () {
    // 現在時刻(サーバ日付)
    const now = moment(Firebase.firestore.Timestamp.now().toDate());
    const cartId = now.format("YYYYMMDDhhmmsss");
    console.log("cartId", cartId);
    return cartId;
  }

  async checkMasterData (t, menu) {
    //===============
    // menu
    //===============
    // 存在チェック
    const menuId = menu.menuId;
    const masterMenuRef = this.db.doc(`${this.rootDoc}/menus/${menuId}`);
    const masterMenuSS = await t.get(masterMenuRef);
    if (!masterMenuSS.exists) {
      throw Error(`not exists(menu): ${menuId}`);
    }

    //TODO とりあえず
    // 更新日付 比較
    const masterM = masterMenuSS.data();
    const masterMUpdatedAt = moment(masterM.updatedAt?.toDate());
    const cartMUpdatedAt = moment(menu.updatedAt?.toDate());
    if (!masterMUpdatedAt.isSame(cartMUpdatedAt)) {
      throw Error(`updatedAt is different (menu): ${masterMUpdatedAt}, ${cartMUpdatedAt}`);
    }

    //===============
    // toppings
    //===============
    const checkToppings = menu.toppings.map(async (topping) => {
      // 存在チェック
      const toppingId = topping.toppingId;
      const masterToppingRef = this.db.doc(
        `${this.rootDoc}/toppings/${toppingId}`
      );
      const masterToppingSS = await t.get(masterToppingRef);
      if (!masterToppingSS.exists) {
        throw Error(`not exists(topping): ${toppingId}`);
      }

      //TODO とりあえず
      // 更新日付 比較
      const masterT = masterToppingSS.data();
      const masterTUpdatedAt = moment(masterT.updatedAt?.toDate());
      const cartTUpdatedAt = moment(topping.updatedAt?.toDate());
      if (!masterTUpdatedAt.isSame(cartTUpdatedAt)) {
        throw Error(`updatedAt is different (topping): ${masterTUpdatedAt}, ${cartTUpdatedAt}`);
      }
    });
    await Promise.all(checkToppings);
  }

  async updateOrderWay (userId, orderStepData) {
    console.log(userId, orderStepData);

    // visitTime
    let visitTimeTs = null;
    if (orderStepData.visitTime) {
      visitTimeTs = this.convert2Timestamp(orderStepData.visitTime);
    }
    console.log("visitTimeTs", visitTimeTs);

    // menu(cart) -> 対象フィールドのみ更新(既存フィールドはそのまま)
    const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);
    const cartSS = await cartRef.get();
    let data = cartSS.data();
    if (!data) {
      data = {};
    }
    data.wayOfOrder = orderStepData.wayOfOrder;
    data.wayOfPay = orderStepData.wayOfPay;
    data.visitTime = visitTimeTs;
    data.sendFromLiff = 1; //LIFFフラグON
    await cartRef.set(data);

    //[DELETE] tmpOrders
    this.deleteTmpOrders(userId);
  }

  convert2Timestamp (HHmmText) {
    const times = HHmmText.split(":");
    console.log(times);

    // 現在時刻(サーバ日付)
    const now = moment(Firebase.firestore.Timestamp.now().toDate());
    console.log("now", now);

    // 入力値を適用した時刻
    const applyDate = moment().set({
      year: now.year(),
      month: now.month(),
      date: now.date(),
      hour: Number(times[0]),
      minute: Number(times[1]),
    });
    return Firebase.firestore.Timestamp.fromDate(applyDate.toDate());
  }

  async existsCartData (userId) {
    return this.countCartData(userId) != 0;
  }

  async countCartData (userId) {
    console.log("userId", userId);
    const baseRef = this.base();
    const menusRef = baseRef
      .collection("users")
      .doc(userId)
      .collection("cart")
      .doc("cartdoc") //固定
      .collection("menus");

    const snapshot = await menusRef.get();
    console.log("size", snapshot.size);
    return snapshot.size;
  }

  async findCartOverview (userId) {
    // ルート document のみ (menus 以外)
    const cartRef = this.db.doc(`${this.rootDoc}/users/${userId}/cart/cartdoc`);
    const cartSS = await cartRef.get();
    const data = cartSS.data();
    if (!data) {
      return {};
    }
    return data;
  }

  async getCurrentCartId (userId) {
    const cart = await this.findCartOverview(userId);
    return cart.cartId;
  }

  // 注文が通っているかどうか
  // 「users/xxx/orders 内に カートID(注文用) を含むかどうか」で判断
  async isOrderPassed (userId, orderCartId) {
    const ordersSS = await this.db
      .collection(`${this.rootDoc}/users/${userId}/orders`)
      .where("cartId", "==", orderCartId)
      .get();

    // データなし
    if (ordersSS.docs.length == 0) {
      console.log("[isOrderPassed] not exist");
      return false;
    }
    // データあり＝それ以外(支払済、キャンセル済)
    console.log("[isOrderPassed] paid");
    return true;
  }

  async deleteTmpOrders (userId) {
    // tmpDoc/menus
    const menusPath = `${this.rootDoc}/users/${userId}/${this.tmpOrders}/tmpDoc/menus`;
    const menusRef = this.db.collection(menusPath);
    const menusSS = await menusRef.get();
    menusSS.docs.forEach((docSS) => {
      docSS.ref.delete();
    });

    // tmpDoc
    const tmpDocPath = `${this.rootDoc}/users/${userId}/${this.tmpOrders}/tmpDoc`;
    await this.db.doc(tmpDocPath).delete();
  }

  async findAbout () {
    const baseRef = this.base();
    const aboutSS = await baseRef
      .collection("about")
      .doc("doc")
      .get();

    const data = aboutSS.data();
    return data;
  }

  async findSettings () {
    const settingsSS = await this.db.doc(`${this.rootDoc}/settings/doc`).get();
    return settingsSS.data();
  }
}

import Firebase from "firebase/app";
import moment from "moment";

// エミュレータ接続
// const ENV = process.env.VUE_APP_NODE_ENV;
// if (ENV === "local") {
//   console.log("### emulator ###");
//   db.settings({
//     host: "localhost:8080",
//     ssl: false,
//   });
// }
export default FirestoreDao;
